export default "__VITE_ASSET__BkaOFG0v__"